import { SpotLightShadow } from '../../thirdparty/three/imports';
import { PerspectiveCamera3D } from '../cameras/PerspectiveCamera3D';
import { LightShadow3D } from './LightShadow3D';

export class SpotLightShadow3D extends LightShadow3D
{
    declare _shadow: SpotLightShadow;

    camera: PerspectiveCamera3D;

    constructor(shadow: SpotLightShadow)
    {
        super();
        this._shadow = shadow;

        this.camera = PerspectiveCamera3D.get(this._shadow.camera);
    }
}
